import { combineReducers } from 'redux-immutable'

import { sessionReducer } from '../scenes/Session/services/reducer'
import { authReducer } from '../scenes/Auth/services/reducer'

const rootReducer = combineReducers({
  session: sessionReducer,
  auth: authReducer
})

export default rootReducer
export { rootReducer }
